module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Buddha Beauty.929026f6.webp";